module.exports = __webpack_public_path__ + "static/media/plan-B5b-mobile-tc.14151a04.png";